import React, {useState, useEffect} from 'react';

import { Select, notification, Form, message } from 'antd';

import { FormattedMessage, useIntl } from 'react-intl';

import _service from '@netuno/service-client';

const langContext = 'components.profile-select';

export default (props) => {
    const intl = useIntl();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(()=> {
        setLoading(true); 
        _service({
            url: "/profile/list",
            success: (response) => {
                setLoading(false);
                setData(response.json);
            },
            fail: (e) => {
                notification["error"]({
                    message: intl.formatMessage({id: `${langContext}.error.message`}),
                    description: e.response.json.error,
                });
            }
        });
    }, []);
    return (
        <Select 
            loading={loading} 
            {...props}
            style={{width: '100%'}} 
            placeholder={intl.formatMessage({id: `${langContext}.placeholder`})}
        >
        {
            data.map((item, key) => (
                <Select.Option key={key} value={item.uid}>{item.description[intl.locale.split('-')[0]]}</Select.Option>
            ))
        }
        </Select>
    );
};

